import { render, staticRenderFns } from "./TopBarLinks.vue?vue&type=template&id=6491b629&scoped=true&"
import script from "./TopBarLinks.vue?vue&type=script&lang=ts&"
export * from "./TopBarLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491b629",
  null
  
)

export default component.exports